var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7111 24.3155C44.7111 24.3155 44.4279 22.3549 43.5557 21.494C42.4512 20.361 41.2164 20.3555 40.65 20.2888C36.5945 20 30.5057 20 30.5057 20H30.4943C30.4943 20 24.4055 20 20.35 20.2888C19.7836 20.3555 18.5488 20.361 17.4443 21.494C16.5721 22.3549 16.2945 24.3155 16.2945 24.3155C16.2945 24.3155 16 26.6204 16 28.9197V31.0747C16 33.3741 16.2889 35.679 16.2889 35.679C16.2889 35.679 16.5721 37.6395 17.4387 38.5004C18.5432 39.6334 19.9932 39.5946 20.6389 39.7167C22.9611 39.9334 30.5 40 30.5 40C30.5 40 36.5945 39.9889 40.65 39.7056C41.2164 39.639 42.4512 39.6334 43.5557 38.5004C44.4279 37.6395 44.7111 35.679 44.7111 35.679C44.7111 35.679 45 33.3796 45 31.0747V28.9197C45 26.6204 44.7111 24.3155 44.7111 24.3155ZM27.5037 33.6906V25.6984L35.3371 29.7084L27.5037 33.6906Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareYoutube);
export default __webpack_public_path__ + "static/media/shareYoutube.418ae888add300b00a95065e47d9e607.svg";
export { ForwardRef as ReactComponent };